import { getMethod } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';
export const VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS';
export const VALIDATE_TOKEN_FAILURE = 'VALIDATE_TOKEN_FAILURE';

// Action Creators
export const validateToken = () => ({
  type: VALIDATE_TOKEN,
});

export const validateTokenSuccess = (data) => ({
  type: VALIDATE_TOKEN_SUCCESS,
  payload: data,
});

export const validateTokenFailure = (error) => ({
  type: VALIDATE_TOKEN_FAILURE,
  payload: error,
});

// Thunk Function
export const validateTokenCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(validateToken());
    try {
      const response = await getMethod(url.validateToken + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(validateTokenSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        if (external?.error === true) {
          external?.handleErrorFunction(response?.data);
          dispatch(validateTokenFailure(response?.data));
        }
      }
    } catch (error) {
      dispatch(validateTokenFailure(error?.message));
    }
  };
};
